@if(!loading){
<div class="p-4 md:p-10">

    <div class="grid grid-cols-1 md:grid-cols-10 gap-x-5  mx-auto mt-5">

       <p-dialog header="Confirmar desvinculación" [(visible)]="showConfirm" [modal]="true" [style]="{width: '400px'}">
         <p class="text-sm">{{ messageModal }}</p>
         <ng-template #footer>
           <button pButton label="Cancelar" class="p-button-text" (click)="showConfirm=false"></button>
           <button pButton label="Desvincular" class="p-button-danger" icon="pi pi-times-circle" (click)="doUnlink()"></button>
         </ng-template>
       </p-dialog>


        <div class="col-span-1  px-2 w-full  pb-16 mx-auto md:col-span-12"
           >
            <div class="flex w-full ">
                <div class="relative  w-full h-full space-y-4 md:space-y-5 mt-5   ">
                    <div class=" h-full w-full overflow-x-auto">
                        <app-custom-table-icon [headers]="headers" [elements]="devices" [iconName]="'Square'"
                            [iconNameSelect]="'SquareCheckBig'"
                            [emptyTableMessage]="'No hay dispositivos  por visualizar'" [hasFilter]="true"
                            [iconColumn]="'driver_id'" [hasButton]="true" [actions]="tableButtons"
                            (dataSelect)="selectDevice($event)"></app-custom-table-icon>

                    </div>


                </div>

            </div>



        </div>
    </div>
</div>
}@else{
<div
    class="bg-slate-800 bg-opacity-50 dark:bg-opacity-70 flex justify-center items-center fixed top-0 right-0 bottom-0 left-0 z-40">
    <ng-container>
        <app-loader [message]="'Procesando'"></app-loader>
    </ng-container>
</div>
}
